import React from 'react';
import styled from 'styled-components';
import { sizeStyles } from './DoctorImage';

const MaybeCircleMask = ({ children, needsMask }) => {
    return needsMask ? (
        <CircleMask data-test="doctor-photo-circle-mask">{children}</CircleMask>
    ) : (
        <>{children}</>
    );
};

const CircleMask = styled.picture`
    ${sizeStyles};

    border-radius: 50%;
    display: inline-block;
    overflow: hidden;
`;

export { CircleMask, MaybeCircleMask, MaybeCircleMask as default };
